import { CONSOLE_PATHS } from "@sagot/constants";
import { lazy, Suspense, type ReactElement } from "react";
import { GuideSkeleton } from "./guide/guide-skeleton";

/** The guide content is large, English-only text: it loads as its own chunk, not with the console shell. */
const GuidePage = lazy(() => import("./guide/guide-page").then((module) => ({ default: module.GuidePage })));

/**
 * Screens owned by the "guide" feature group, keyed by CONSOLE_PATHS value. The guide needs no permission:
 * every member of the workspace can read it (its sidebar item has none either).
 */
export const guideScreens: Readonly<Record<string, ReactElement>> = {
  [CONSOLE_PATHS.guide]: (
    <Suspense fallback={<GuideSkeleton />}>
      <GuidePage />
    </Suspense>
  ),
};
